module.exports = __webpack_public_path__ + "img/legacy-shape-20.7ad284d7.png";